const truncateString = (value: string, maxLength = 32): string => {
  if (!value) return null;
  const showEllipsis = value.length > maxLength;
  return `${value.substring(0, maxLength).trim()}${showEllipsis ? '...' : ''}`;
};

export default truncateString;
